"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var routeModuleHmrPlugin_exports = {};
__export(routeModuleHmrPlugin_exports, {
  createRouteModuleHmrPlugin: () => createRouteModuleHmrPlugin
});
module.exports = __toCommonJS(routeModuleHmrPlugin_exports);
var import_path = __toESM(require("path"), 1);
var import_routeFileWatch = require("../../utils/routeFileWatch");
function createRouteModuleHmrPlugin(routerRoot) {
  return {
    name: "route-module-hmr-fix",
    // the router swallows a failed route import and renders an empty component
    // in its place (see useViteRoutes resolve). that is right for production and
    // wrong for dev, where it meant a broken import anywhere in a route's module
    // graph produced a blank app, no terminal output, and one console line — with
    // every provider inside that route silently never mounting. the client paints
    // its own overlay (devtools/dev.mjs) and reports here so the failure also
    // reaches the terminal, where the person running the dev server is looking.
    configureServer(server) {
      server.hot.on("one:route-error", function(data) {
        var id = (data === null || data === void 0 ? void 0 : data.id) || "unknown route";
        var message = (data === null || data === void 0 ? void 0 : data.message) || "unknown error";
        server.config.logger.error(`[one] route failed to load: ${id}
  ${message}
  the router rendered an empty component in its place, so nothing inside this route mounted.`, {
          timestamp: true
        });
      });
    },
    hotUpdate(param) {
      var { server, modules, file } = param;
      var _this_environment;
      var absoluteRouterRoot = import_path.default.resolve(server.config.root, routerRoot);
      var fileRelativePath = import_path.default.relative(server.config.root, file);
      if (((_this_environment = this.environment) === null || _this_environment === void 0 ? void 0 : _this_environment.name) === "ssr" && (0, import_routeFileWatch.isPathInsideDirectory)(file, absoluteRouterRoot)) {
        return [];
      }
      var hasRouteUpdate = false;
      var result = modules.map(function(module2) {
        if (!module2.id) return module2;
        var moduleFile = module2.id.split("?")[0];
        if ((0, import_routeFileWatch.isPathInsideDirectory)(moduleFile, absoluteRouterRoot)) {
          var relativeRoutePath = import_path.default.relative(absoluteRouterRoot, moduleFile);
          module2.acceptedHmrExports = /* @__PURE__ */ new Set();
          if (/^(?:\([^)]+\)[\\/])?_layout\.[jt]sx?$/.test(relativeRoutePath)) {
            hasRouteUpdate = true;
          }
        }
        return module2;
      });
      if (hasRouteUpdate) {
        server.hot.send({
          type: "custom",
          event: "one:route-update",
          data: {
            file: fileRelativePath
          }
        });
      }
      return result;
    }
  };
}
//# sourceMappingURL=routeModuleHmrPlugin.js.map
